/* ============================================================
   Hepalife — Liver Cleanse & Detox (slug 'hepalife').
   Cargado por layout/landing.liquid (case 'hepalife').
   Bloques: galería (thumbs) · selección de bundle (.hl-bundle) ·
   disparo del modal Releasit COD · sticky bar.
   Patrón Releasit (per-unit + quantity): cada bundle = 1 variante con precio
   POR UNIDAD; mandamos quantity = N (unidades) para que el pedido lleve las
   unidades reales (Dropi) y el total quede en el precio del bundle. Releasit
   lee input[name="quantity"] del DOM al disparar. NO usar _rsiV2.setState como
   primer path — el click nativo del botón Releasit SÍ re-lee productData.
   Ver memory/project_bundles_as_variants.
   ============================================================ */

/* ---------- Galería del buy-box ---------- */
(function () {
  var thumbs = [].slice.call(document.querySelectorAll('#galThumbs img'));
  var galSrc = thumbs.map(function (i) { return i.getAttribute('src'); });
  var galI = 0;
  window.galGo = function (i) {
    if (!galSrc.length) return;
    galI = (i + galSrc.length) % galSrc.length;
    var main = document.getElementById('galMain');
    if (main) main.src = galSrc[galI];
    document.querySelectorAll('.hl-thumb').forEach(function (t, x) { t.classList.toggle('active', x === galI); });
  };
  window.galNext = function () { window.galGo(galI + 1); };
  window.galPrev = function () { window.galGo(galI - 1); };
})();

/* ---------- Testimonios ---------- */
window.testiScroll = function (d) {
  var t = document.getElementById('testiTrack');
  if (t) t.scrollBy({ left: d * 362, behavior: 'smooth' });
};
window.scrollTop = function () { window.scrollTo({ top: 0, behavior: 'smooth' }); };

/* ---------- Sticky bar ---------- */
(function () {
  var sticky = document.getElementById('stickyBar');
  if (!sticky) return;
  window.addEventListener('scroll', function () {
    sticky.classList.toggle('show', window.scrollY > 700);
  });
})();

/* ============================================================
   Releasit COD trigger + selección de bundle
   ============================================================ */
var HEPALIFE_RELEASIT_SELECTORS = [
  '#rsi_buy_now_button',
  '.rsi_buy_now_button',
  '._rsi-buy-now-button',
  '._rsi-buy-now-button-app-block-hook button',
  '._rsi-buy-now-button-app-block-hook a',
  '.rsi-btn-skel'
];

function hepalifeFindReleasitButton() {
  for (var i = 0; i < HEPALIFE_RELEASIT_SELECTORS.length; i++) {
    var el = document.querySelector(HEPALIFE_RELEASIT_SELECTORS[i]);
    if (el) return el;
  }
  return null;
}

var hepalifeSelectedVariantId = null;
var hepalifeSelectedQty = 1;

// Cada bundle = una variante con precio POR UNIDAD; mandamos la cantidad real
// (1/3/5 frascos) para que el pedido llegue con las unidades exactas (Dropi
// envía la cantidad) y el total quede en el precio del bundle. Releasit lee el
// input[name="quantity"] del DOM al disparar COD.
function hepalifeSetVariantOnAllForms(variantId, qty) {
  if (!variantId) return;
  var q = parseInt(qty, 10);
  if (!q || q < 1) q = 1;
  document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
    input.value = String(q);
    input.setAttribute('value', String(q));
  });
  if (window.productData) { window.productData.quantity = q; }
  if (window.productData && Array.isArray(window.productData.variants)) {
    var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
    if (v) {
      window.productData.selected_or_first_available_variant = v;
      window.productData.selected_variant = v;
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
        document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
      } catch (e) {}
    }
  }
}

function hepalifeBundleQty(el) {
  var q = parseInt(el.getAttribute('data-bundle-qty'), 10);
  if (!q) { q = parseInt(el.getAttribute('data-units'), 10); }
  return q || 1;
}

/* ---------- Selección de bundle ---------- */
function selBundle(el) {
  document.querySelectorAll('.hl-bundle').forEach(function (b) { b.classList.remove('sel'); });
  el.classList.add('sel');
  var id = el.getAttribute('data-bundle-variant-id');
  if (id) {
    hepalifeSelectedVariantId = id;
    hepalifeSelectedQty = hepalifeBundleQty(el);
    hepalifeSetVariantOnAllForms(id, hepalifeSelectedQty);
  }
}
window.selBundle = selBundle;

function hepalifeTriggerCOD(btn) {
  var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || hepalifeSelectedVariantId;
  var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || hepalifeSelectedQty;
  if (variantId) hepalifeSetVariantOnAllForms(variantId, qty);
  setTimeout(function () {
    var releasitBtn = hepalifeFindReleasitButton();
    if (releasitBtn) { releasitBtn.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = hepalifeFindReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }, 50);
}
window.hepalifeTriggerCOD = hepalifeTriggerCOD;
// Alias: el CTA principal y el sticky llaman openCheckout()
window.openCheckout = function () { hepalifeTriggerCOD(null); };
window.closeCheckout = function () {
  var m = document.getElementById('modalBg');
  if (m) m.classList.remove('show');
};

/* ---------- Init: bundle preseleccionado (.sel o el primero) ---------- */
(function () {
  var active = document.querySelector('.hl-bundle.sel') || document.querySelector('.hl-bundle');
  if (active) selBundle(active);
})();
